import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

//utils
import queries from '../../../../src/utils/queries'

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import selciudad from '../../../functions/selciudad';

const DetalleNivel1 = props => {
  return (
    <option value={props.elemento._id}>{props.elemento.descrPerfil}</option>
  )
};

const Lista = ({list, styles, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="perfil" id="miListaP" value={permiteUpdate?argsDocum.idPerfil:idLista.perfil._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

// //Ciudades
// const DetalleNivel1C = props => {
//   return (
//     <option dato1={props.elemento.codigoDpto} dato2={props.elemento.descrDpto} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
//   )
// };

// const ListaC = ({listC, styles, idLista, argsDocum, permiteUpdate, handleChange}) => {
//   const Nivel1Detalle = listC.map((elemento, _id) => <DetalleNivel1C elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       <select style={styles.input} className="ui simple selection dropdown fluid" name="ciudad" id="miLista1" value={permiteUpdate?argsDocum.codigoCiudad:idLista.codigoCiudad} onChange={(ev)=>handleChange(ev, argsDocum)}>
//         {Nivel1Detalle}
//       </select>
//     </div>
//   )
// };
// //FIN ciudades

//Oficinas
const DetalleNivel1Of = props => {
  return (
    <option>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({listOf, styles, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = listOf.map((elemento, _id) => <DetalleNivel1Of elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oficina" id="miListaOf" value={permiteUpdate?argsDocum.descrOficina:idLista.descrOficina} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN Oficinas

//Terceros
const DetalleNivel1T = props => {
  return (
    <option value={props.elemento.numeroDocum}>{props.elemento.descrRecurso}</option>
  )
};

const ListaT = ({listT, styles, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = listT.map((elemento, _id) => <DetalleNivel1T elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="miListaT" value={permiteUpdate?argsDocum.numeroDocum:idLista.numeroDocum} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN terceros

//Tipo de recursos
const DetalleNivel1TR = props => {
  return (
    <option value={props.elemento.descrTipoRec}>{props.elemento.descrTipoRec}</option>
  )
};

const ListaTR = ({listTR, styles, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = listTR.map((elemento, _id) => <DetalleNivel1TR elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrTipoRec" id="miListaTR" value={permiteUpdate?argsDocum.descrTipoRec:idLista.descrTipoRec} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN Tipo de recursos

class VerUsu2 extends React.Component {
  state={
    argsDocum: {email: this.props.idLista.email,
                nombreUsuario: this.props.idLista.nombreUsuario,
                estadoUsuario: this.props.idLista.estadoUsuario,
                idPerfil: this.props.idLista.perfil._id,
                descrPerfil: this.props.idLista.perfil.descrPerfil,
                descrOficina: this.props.idLista.descrOficina,
                _id: this.props.idLista._id,
                _idDpto: this.props.idLista._idDpto,
                codigoDpto: this.props.idLista.codigoDpto,
                descrDpto: this.props.idLista.descrDpto,
                codigoCiudad: this.props.idLista.codigoCiudad,
                nombreCiudad: this.props.idLista.nombreCiudad,
                numeroDocum: this.props.idLista.numeroDocum,
                descrTipoRec: this.props.idLista.descrTipoRec,
                userApp: this.props.idLista.userApp},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      // console.log(ev.target.name, ev.target.value)

      if(ev.target.name !== "email"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "perfil"){
          let miLista = document.getElementById("miListaP");
          argsDocum['descrPerfil'] = miLista.options[miLista.selectedIndex].text
          argsDocum['idPerfil'] = miLista.options[miLista.selectedIndex].value
        }else{
          if(ev.target.name === "dpto"){
            let miLista = document.getElementById("miLista");
            // argsDocum['codigoCiudad'] = miLista.options[miLista.selectedIndex].value

            if(miLista.options[miLista.selectedIndex].text==="Todos..."){
              argsDocum['_idDpto'] = "Todos..."
              argsDocum['codigoDpto'] = "Todos..."
              argsDocum['descrDpto'] = "Todos..."
              argsDocum['codigoCiudad'] = "Todas..."
              argsDocum['nombreCiudad'] = "Todas..."
            }else{
              argsDocum['_idDpto'] = miLista.options[miLista.selectedIndex].value
              argsDocum['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
              argsDocum['descrDpto'] = miLista.options[miLista.selectedIndex].text

              miLista = document.getElementById("miLista1");
              if(miLista.options[miLista.selectedIndex].text==="Todas..."){
                argsDocum['codigoCiudad'] = "Todas..."
                argsDocum['nombreCiudad'] = "Todas..."
              }else{
                argsDocum['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
                argsDocum['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
              }
            }
          }else{  
            if(ev.target.name === "tercero"){
              let miLista = document.getElementById("miListaT");
              argsDocum['numeroDocum'] = miLista.options[miLista.selectedIndex].value
            }else{
              if(ev.target.name === "userApp"){
                argsDocum[ev.target.name] = ev.target.checked
              }else{
                if(ev.target.name === "oficina"){
                  let miLista = document.getElementById("miListaOf");
                  argsDocum['descrOficina'] = miLista.options[miLista.selectedIndex].text
                }else{
                  if(ev.target.name === "estadoUsuario"){
                    if(argsDocum.estadoUsuario === true){
                      argsDocum[ev.target.name] = false
                    }else{
                      argsDocum[ev.target.name] = true
                    }
                  }else{
                    argsDocum[ev.target.name] = ev.target.value
                  }
                }
              }
            }
          }
        }
        // console.log(argsDocum)
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;
    // console.log(argsDocum)
    // console.log(this.props.idLista)

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let argsSelDpto = {...argsDocum}
    argsSelDpto._id = argsDocum._idDpto
    let colecc = selciudad(this.props.list1, argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let esUpd = true
    
    let listaCPer = []
    if(this.props.data.allPerfiles){listaCPer = this.props.data.allPerfiles}
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large user plus yellow icon"></i>
          Usuario
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Correo electrónico</label>
                    <input style={this.props.styles.input} autoComplete="off" name="email" id="email" value={this.state.argsDocum.email} onChange={this.handleChange} placeholder='Correo electrónico' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'email'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Nombre del usuario</label>
                    <input style={this.props.styles.input} autoComplete="off" name="nombreUsuario" id="nombreUsuario" value={this.props.permiteUpdate?this.state.argsDocum.nombreUsuario:this.props.idLista.nombreUsuario} onChange={this.handleChange} placeholder='Nombre del usuario' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreUsuario'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Perfil</label>
                    <Lista list={listaCPer} styles={this.props.styles} idLista={this.props.idLista} argsDocum={this.state.argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Oficina</label>
                    <ListaOf listOf={this.props.list2} styles={this.props.styles} idLista={this.props.idLista} argsDocum={this.state.argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Solo clientes del Departamento</label>
                          <ListaDe list={this.props.list1} styles={this.props.styles} handleLista={this.handleChange}
                            codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                            esUpd={esUpd}
                            argsDocum={argsDocum} idLista={this.props.idLista} permiteUpdate={this.props.permiteUpdate}/>
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Solo clientes de la Ciudad</label>
                          <ListaCi list={listCiu} styles={this.props.styles} handleLista1={this.handleChange}
                            codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                            esUpd={esUpd}
                            argsDocum={argsDocum} idLista={this.props.idLista} permiteUpdate={this.props.permiteUpdate}/>
                        </div>
                      </div>
                    </div>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>En Recibir pago - Terceros, solo recibir del tercero</label>
                    <ListaT listT={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={this.state.argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Solo OS del tipo de recurso</label>
                    <ListaTR listTR={this.props.listTR} styles={this.props.styles} idLista={this.props.idLista} argsDocum={this.state.argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  
                  <Form.Field>
                      <label style={this.props.styles.label}>INACTIVO / ACTIVO</label>
                      <Form.Checkbox name="estadoUsuario" id="estadoUsuario" className='ui fitted toggle checkbox' checked={argsDocum.estadoUsuario} onChange={this.handleChange}/>
                  </Form.Field>

                  <Form.Field>
                    <p style={{color: '#FFE000', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="userApp" id="userApp"
                           checked={this.props.permiteUpdate?argsDocum.userApp:this.props.idLista.userApp} onChange={this.handleChange}/>
                      &nbsp;&nbsp;Usuario App
                    </p>
                  </Form.Field>
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default graphql(queries.query.allPerfiles)(VerUsu2)
